import { ActionEnum } from "../core/dto/abstract-action.dto";
import { ActionCommand } from "./action-command-interface";
import { AddNewAddressCommand } from "./commands/add-new-address.command";
import { ApplyRemovePromoCommand } from "./commands/apply-promo.command";
import { AutosuggestCommand } from "./commands/autosuggest.command";
import { BusinessRegistrationCommand } from "./commands/business-registration.command";
import { CallNowCommand } from "./commands/call-now.command";
import { CartCheckoutActionCommand } from "./commands/cart-checkout-action.command";
import { ConfirmCodOrderCommand } from "./commands/confirm-cod-order.command";
import { DeleteAddressCommand } from "./commands/delete-address.command";
import { ExternalNavigationCommand } from "./commands/external-navigation.command";
import { IbCreditLeadCreationCommand } from "./commands/ib-credit-lead-creation.command";
import { InitiatePaymentCommand } from "./commands/initiate-payment.command";
import { InitiateReturnRequestCommand } from "./commands/initiate-return-request.command";
import { LoginVerificationCommand } from "./commands/login-verification.command";
import { LoginCommand } from "./commands/login.command";
import { LogoutCommand } from "./commands/logout.command";
import { MergeQueryParamsCommand } from "./commands/merge-query-params.command";
import { NavigateByUrlCommand } from "./commands/navigate-by-url.command";
import { NavigationRouterCommand } from "./commands/navigation-router.command";
import { NavigationCommand } from "./commands/navigation.command";
import { NpsFeedbackCommand } from "./commands/nps-feedback.command";
import { PdpRequestFormsCommand } from "./commands/pdp-request-forms.command";
import { PincodeServiceabilityCommand } from "./commands/pincode-serviceability.command";
import { PopupCommand } from "./commands/popup.command";
import { ProfileActionCommand } from "./commands/profile-action.command";
import { RemoveFromCartCommand } from "./commands/remove-from-cart.command";
import { ResendOtpCommand } from "./commands/resend-otp.command";
import { SaveAddressCommand } from "./commands/save-address.command";
import { SaveProductReviewCommand } from "./commands/save-product-review.command";
import { SelectAddressTypeCommand } from "./commands/select-address-type.command";
import { SelectAddressCommand } from "./commands/select-address.command";
import { SelectPaymentCommand } from "./commands/select-payment.command";
import { SendOtpCommand } from "./commands/send-otp.command";
import { ShareCommand } from "./commands/share.command";
import { SubmitNpsRatingCommand } from "./commands/submit-nps-rating.command";
import { SubmitUserQuoteCommand } from "./commands/submit-user-quote.command";
import { UpdateProductQuantityCommand } from "./commands/update-product-quantity.command";
import { UpdateAddressCommand } from "./commands/update.address.command";
import { VerifyDealerCodeCommand } from "./commands/verify-dealer-code.command";
import { VerifyGstCommand } from "./commands/verify-gst.command";
import { VerifyOtpCommand } from "./commands/verify-otp.command";

export class ActionCommandFactory {
  private commandMap: Map<ActionEnum, () => ActionCommand>;
  constructor(private renderEngineComponent: any) {
    this.commandMap = new Map<ActionEnum, () => ActionCommand>([
      [ActionEnum.NAVIGATION, () => new NavigationCommand(this.renderEngineComponent)],
      [ActionEnum.NAVIGATION_ROUTER, () => new NavigationRouterCommand(this.renderEngineComponent)],
      [ActionEnum.EXTERNAL_NAVIGATION, () => new ExternalNavigationCommand()],
      [ActionEnum.UPDATE_PRODUCT_QUANTITY, () => new UpdateProductQuantityCommand()],
      [ActionEnum.SERVICEABILITY_AT_PINCODE, () => new PincodeServiceabilityCommand(this.renderEngineComponent)],
      [ActionEnum.VERIFY_DEALER_CODE, () => new VerifyDealerCodeCommand()],
      [ActionEnum.AUTOSUGGEST, () => new AutosuggestCommand(this.renderEngineComponent)],
      [ActionEnum.ADD_TO_CART, () => new CartCheckoutActionCommand()],
      [ActionEnum.BUY_NOW, () => new CartCheckoutActionCommand()],
      [ActionEnum.SUBMIT_NPS_RATING, () => new SubmitNpsRatingCommand()],
      [ActionEnum.REMOVE_FROM_CART, () => new RemoveFromCartCommand()],
      [ActionEnum.ADDRESS_SELECT, () => new SelectAddressCommand()],
      [ActionEnum.ADDRESS_UPDATE, () => new UpdateAddressCommand()],
      [ActionEnum.ADDRESS_NEW, () => new AddNewAddressCommand(this.renderEngineComponent)],
      [ActionEnum.ADDRESS_SAVE, () => new SaveAddressCommand()],
      [ActionEnum.ADDRESS_DELETE, () => new DeleteAddressCommand()],
      [ActionEnum.INIT_PAYMENT, () => new InitiatePaymentCommand()],
      [ActionEnum.SELECT_PAYMENT, () => new SelectPaymentCommand(this.renderEngineComponent)],
      [ActionEnum.CONFIRM_ORDER_COD, () => new ConfirmCodOrderCommand()],
      [ActionEnum.BUSINESS_REGISTRATION, () => new BusinessRegistrationCommand()],
      [ActionEnum.RESEND_EMAIL_VERIFICATION_LINK, () => new LoginVerificationCommand()],
      [ActionEnum.VERIFY_EMAIL_EXISTENCE, () => new LoginVerificationCommand()],
      [ActionEnum.BUSINESS_BILLING_ADDRESS, () => new LoginVerificationCommand()],
      [ActionEnum.BUSINESS_CHANGE_PHONE_NO, () => new LoginVerificationCommand()],
      [ActionEnum.VERIFY_MOBILE_NO, () => new LoginVerificationCommand()],
      [ActionEnum.FORGOT_PASSWORD, () => new LoginVerificationCommand()],
      [ActionEnum.CONTINUE_WITH_OTP, () => new LoginVerificationCommand()],
      [ActionEnum.VERIFY_USER, () => new LoginVerificationCommand()],
      [ActionEnum.REGISTRATION, () => new LoginCommand(this.renderEngineComponent)],
      [ActionEnum.RESET_PASSWORD, () => new LoginCommand(this.renderEngineComponent)],
      [ActionEnum.ASSISTED_SALES_LOGIN, () => new LoginCommand(this.renderEngineComponent)],
      [ActionEnum.LOGIN, () => new LoginCommand(this.renderEngineComponent)],
      [ActionEnum.LOGOUT, () => new LogoutCommand(this.renderEngineComponent)],
      [ActionEnum.VERIFY_OTP, () => new VerifyOtpCommand()],
      [ActionEnum.RESEND_OTP, () => new ResendOtpCommand()],
      [ActionEnum.SEND_OTP, () => new SendOtpCommand()],
      [ActionEnum.UPDATE_PROFILE, () => new ProfileActionCommand()],
      [ActionEnum.CANCEL_ORDER, () => new ProfileActionCommand()],
      [ActionEnum.RETURN_REQUEST_CANCEL, () => new ProfileActionCommand()],
      [ActionEnum.BANK_ACCOUNT_DELETE, () => new ProfileActionCommand()],
      [ActionEnum.BANK_ACCOUNT_SELECT_DEFAULT, () => new ProfileActionCommand()],
      [ActionEnum.UPDATE_PASSWORD, () => new ProfileActionCommand()],
      [ActionEnum.POPUP, () => new PopupCommand()],
      [ActionEnum.APPLY_PROMO, () => new ApplyRemovePromoCommand()],
      [ActionEnum.REMOVE_PROMO, () => new ApplyRemovePromoCommand()],
      [ActionEnum.SHARE, () => new ShareCommand(this.renderEngineComponent)],
      [ActionEnum.ADDRESS_TAB_SELECT, () => new SelectAddressTypeCommand()],
      [ActionEnum.VERIFY_GST, () => new VerifyGstCommand()],
      [ActionEnum.QUERY_PARAMS, () => new MergeQueryParamsCommand(this.renderEngineComponent)],
      [ActionEnum.RETURN_REQUEST_INITIATE, () => new InitiateReturnRequestCommand()],
      [ActionEnum.PRODUCT_REVIEW_SAVE, () => new SaveProductReviewCommand()],
      [ActionEnum.CALL_NOW, () => new CallNowCommand()],
      [ActionEnum.REQUEST_A_CALLBACK, () => new PdpRequestFormsCommand()],
      [ActionEnum.QUOTE_ONLY, () => new PdpRequestFormsCommand()],
      [ActionEnum.GET_CUSTOMIZED_PRICE, () => new PdpRequestFormsCommand()],
      [ActionEnum.NAVIGATE_BY_URL, () => new NavigateByUrlCommand()],
      [ActionEnum.UPDATE_GSTIN_IN_ADDRESS, () => new CartCheckoutActionCommand() ],
      [ActionEnum.SUBMIT_USER_QUOTE, () => new SubmitUserQuoteCommand() ],
      [ActionEnum.POPUP_CLOSE, () => new PopupCommand()],
      [ActionEnum.PAY_INVOICE, () => new ProfileActionCommand()],
      [ActionEnum.PAY_ALL_OUTSTANDING, () => new ProfileActionCommand()],
      [ActionEnum.NPS_FEEDBACK, () => new NpsFeedbackCommand()],
      [ActionEnum.SUBMIT_IB_CREDIT_FORM, () => new IbCreditLeadCreationCommand()],
      [ActionEnum.COMPLETE_IB_CREDIT_FIRST_STEP, () => new IbCreditLeadCreationCommand()],
      [ActionEnum.GOTO_IB_CREDIT_FIRST_STEP, () => new IbCreditLeadCreationCommand()],
    ]);
  }

  createCommand(actionType: ActionEnum): ActionCommand {
    const commandFactory:()=>ActionCommand = this.commandMap.get(actionType);
    if (!commandFactory) {
      throw new Error('Unknown action type');
    }
    return commandFactory();
  }
}